import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { UserTeams } from '@/shared/enums/user-teams.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const LeadsListContainer = React.lazy(
  () => import('../../containers/leads-list/leads-list.container')
);

const LeadsAddContainer = React.lazy(
  () => import('../../containers/leads-add/leads-add.container')
);

const LeadDetailsContainer = React.lazy(
  () => import('../../containers/leads-details/leads-details.container')
);

const LeadDashboardContainer = React.lazy(
  () => import('../../containers/leads-dashboard/leads-dashboard.container')
);
const LeadsEditContainer = React.lazy(
  () => import('../../containers/leads-edit/leads-edit.container')
);

const MarketingAttributionDashboardContainer = React.lazy(
  () =>
    import(
      '../../containers/marketing-attribution-dashboard/marketing-attribution-dashboard.container'
    )
);

export const LeadsRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={(APP_ROUTES.LEADS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
  },
  {
    path: (APP_ROUTES.LEADS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.SALES_AGENT,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT,
            UserRole.E_COMMERCE_AUTO,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.ADMIN
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={LeadsListContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.LEADS_MODULE.CHILDREN as RouteConfig).ADD.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.SALES_AGENT,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT,
            UserRole.E_COMMERCE_AUTO,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.ADMIN
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={LeadsAddContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.LEADS_MODULE.CHILDREN as RouteConfig).DETAILS.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.SALES_AGENT,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.E_COMMERCE_AUTO,
            UserRole.ADMIN
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={LeadDetailsContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.LEADS_MODULE.CHILDREN as RouteConfig).DASHBOARD.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.SALES_AGENT,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.MARKETING_EXECUTIVE,
            UserRole.ADMIN
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={LeadDashboardContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.LEADS_MODULE.CHILDREN as RouteConfig).ATTRIBUTION_DASHBOARD.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.MARKETING_EXECUTIVE,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.ADMIN
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={MarketingAttributionDashboardContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.LEADS_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.SALES_AGENT,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.E_COMMERCE_AUTO,
            UserRole.ADMIN
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={LeadsEditContainer}
        />
      </React.Suspense>
    )
  }
];
